import { UUID } from '../models';

export const buildMeasurementKey = (monitoringId: UUID, inspectionId: UUID, characteristicId: UUID): string =>
  `${monitoringId}:${inspectionId}:${characteristicId}`;

export const findParentById = (array, id) => array.find(item => item.id === id);

export const getAllParentsAsString = (array, node, path: string[] = []) => {
  const defaultName = [node.name, ...path];

  if (node.parentId === null) {
    return defaultName.join(' / ');
  }

  const parent = findParentById(array, node.parentId);

  if (!parent) {
    return defaultName.join(' / ');
  }

  return getAllParentsAsString(array, parent, defaultName);
};
